import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal/Modal';

import Account from '../Account/Account';

var AccountModal = function AccountModal(_ref) {
  var isAccountModalOpen = _ref.isAccountModalOpen,
      toggleAccountModal = _ref.toggleAccountModal,
      toggleAccountForm = _ref.toggleAccountForm,
      formType = _ref.formType;
  return React.createElement(
    Modal,
    {
      active: isAccountModalOpen,
      closeModalFunc: function closeModalFunc() {
        return toggleAccountModal({ active: false, formType: '' });
      }
    },
    React.createElement(Account, {
      toggleAccountForm: toggleAccountForm,
      formType: formType,
      isModal: true
    })
  );
};

AccountModal.propTypes = {
  isAccountModalOpen: PropTypes.bool.isRequired,
  formType: PropTypes.oneOf(['', 'LOGIN', 'REGISTER', 'RECOVER', 'WISHLIST']),
  toggleAccountModal: PropTypes.func.isRequired,
  toggleAccountForm: PropTypes.func.isRequired
};

export default AccountModal;